import { remove } from 'diacritics';

const specialCharsRegex = /[.*+?^${}()|[\]\\]/g;
const wordCharacterRegex = /[a-z0-9_]/i;
const whitespacesRegex = /\s+/;

const escapeRegexCharacters = str => str.replace(specialCharsRegex, '\\$&');

function extend(subject = {}, baseObject) {
  const newBaseObject = baseObject;
  Object.keys(subject).forEach(key => {
    newBaseObject[key] = !!subject[key];
  });
  return newBaseObject;
}

const match = (text, query, options) => {
  const extendedOptions = extend(options, {
    insideWords: false,
    findAllOccurrences: false,
    requireMatchAll: false,
  });

  let purgedText = remove(text);
  const purgedQuery = remove(query);

  return (
    purgedQuery
      .trim()
      .split(whitespacesRegex)
      // If query is blank, we'll get empty string here, so let's filter it out.
      .filter(word => word.length > 0)
      .reduce((result, word) => {
        const wordLen = word.length;
        const prefix =
          !extendedOptions.insideWords && wordCharacterRegex.test(word[0]) ? '\\b' : '';
        const regex = new RegExp(prefix + escapeRegexCharacters(word), 'i');

        let occurrence = regex.exec(text);
        if (extendedOptions.requireMatchAll && occurrence === null) {
          purgedText = '';
          return [];
        }

        while (occurrence) {
          const { index } = occurrence;
          result.push([index, index + wordLen]);

          // Replace what we just found with spaces so we don't find it again.
          purgedText =
            purgedText.slice(0, index) +
            new Array(wordLen + 1).join(' ') +
            purgedText.slice(index + wordLen);

          if (!extendedOptions.findAllOccurrences) {
            break;
          }

          occurrence = regex.exec(purgedText);
        }

        return result;
      }, [])
      .sort((match1, match2) => match1[0] - match2[0])
  );
};

export default match;
